import React from 'react';
import { Button, Dialog, DialogTrigger, OverlayArrow, Popover as RACPopover, PopoverProps } from 'react-aria-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faXmark } from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from 'react-i18next';

import './index.scss';

interface Props {
  title: string;
  descriptionOne?: string;
  size?: 'medium' | 'large';
  placement?: PopoverProps['placement'];
}

export const Popover = ({ size = 'medium', title, descriptionOne, placement }: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { t } = useTranslation();

  return (
    <DialogTrigger>
      <Button type="button" className="myd-popover__trigger" aria-label={t('helpHints.moreInformation')} onPress={() => setIsOpen(true)}>
        <FontAwesomeIcon icon={faCircleInfo} className="rac-input-label-icon" />
      </Button>
      <RACPopover className={`myd-popover myd-popover__size-${size}`} isOpen={isOpen} onOpenChange={setIsOpen} placement={placement}>
        <OverlayArrow>
          <svg width="16" height="16" viewBox="0 2 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0711 0.485289C14.962 0.485289 15.4081 1.56243 14.7782 2.1924L8.70711 8.26347C8.31658 8.654 7.68342 8.654 7.29289 8.26347L1.22183 2.1924C0.591867 1.56243 1.03803 0.485289 1.92894 0.485289L14.0711 0.485289Z" />
          </svg>
        </OverlayArrow>
        <Dialog>
          <div className="myd-popover__border"></div>
          <div className="myd-popover__title-row">
            <div data-testid="tip-title" className="myd-popover__title">
              {title}
            </div>
            <button className="myd-popover__close-button" onClick={() => setIsOpen(false)} aria-label={t('close')}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
          {descriptionOne && (
            <div data-testid="tip-description-one" className="myd-popover__description-one">
              {descriptionOne}
            </div>
          )}
        </Dialog>
      </RACPopover>
    </DialogTrigger>
  );
};

export default Popover;
